module.exports = __webpack_public_path__ + "img/bingo_ball-68.478ea255.png";